export default __webpack_public_path__ + "static/media/local_offer.58f66197.svg";